import script from "./TextEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./TextEditor.vue?vue&type=script&setup=true&lang=js"

import "./TextEditor.vue?vue&type=style&index=0&id=15558a4d&lang=scss"

export default script